import {
  Component,
  Input,
  ElementRef,
  AfterContentInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { pie, select, arc, Arc, interpolate, Selection } from 'd3';

interface DonutChartData {
  color: string;
  value: number;
  thickness?: number;
}

@Component({
  selector: 'muni-gameday-donut-chart',
  template: '<svg></svg>'
})
class DonutChartComponent implements AfterContentInit, OnChanges {
  @Input()
  data: DonutChartData[];
  @Input()
  innerRadius: number;
  @Input()
  outerRadius: number;
  @Input()
  transitionDuration = 1000;

  private svg: Selection<SVGSVGElement, any, any, any>;
  private pie; //: Selection<any, any, any, any>;

  private pieLayout = pie<DonutChartData>()
    .sort(undefined)
    .value((d) => d.value);

  constructor(private elementRef: ElementRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.svg && this.data) {
      this.render(this.data);
    }
  }

  public ngAfterContentInit(): void {
    this.svg = select(this.elementRef.nativeElement).select('svg');
    this.pie = this.svg
      .html('')
      .attr('width', this.outerRadius * 2)
      .attr('height', this.outerRadius * 2)
      .append('g')
      .attr('transform', `translate(${this.outerRadius},${this.outerRadius})`);
    if (this.data) {
      this.render(this.data);
    }
  }

  private render(data) {
    const { innerRadius, outerRadius, transitionDuration, pieLayout } = this;

    const arcOuter = arc<DonutChartData>().outerRadius(outerRadius);

    function getArc(d: { data: DonutChartData }): Arc<any, DonutChartData> {
      return arcOuter.innerRadius(
        d.data.thickness ? outerRadius - d.data.thickness : innerRadius
      );
    }

    const segments = this.pie.selectAll('path').data(pieLayout(data));

    segments
      .attr('fill', (d) => d.data.color)
      .transition()
      .duration(transitionDuration)
      .attrTween('d', function (d, i) {
        const interpolated = interpolate(this._current, d as any);
        this._current = interpolated(0);
        return (t) => getArc(d)(interpolated(t) as any);
      });

    segments
      .enter()
      .append('path')
      .attr('fill', (d) => d.data.color)
      .attr('d', (d) => getArc(d)(d as any))
      .each(function (d) {
        this._current = d;
      });

    segments.exit().remove();
  }
}

export { DonutChartComponent, DonutChartData };
